import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import SubscriberDashboard from './pages/subscriber/SubscriberDashboard';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import UnauthorizedPage from './pages/UnauthorizedPage';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import Dashboard from './pages/Dashboard';
import UserApprovals from './pages/admin/UserApprovals';
import HomePage from './pages/HomePage';
import { UserRole } from './types/user'; // <-- !! استيراد UserRole enum !!
import TrainingApplication from './pages/subscriber/TrainingApplication';
import TrainingRequestsList from './pages/admin/subscribers/TrainingRequestsList';
import DataImportPage from './pages/admin/DataImportPage';
import ServicesManagementPage from './pages/admin/ServicesManagementPage';
import TraineesListPage from './pages/admin/trainees/TraineesListPage';
import AddTraineePage from './pages/admin/trainees/AddTraineePage'; // <-- أضف هذا السطر
import EditTraineePage from './pages/admin/trainees/EditTraineePage';
import LawyersListPage from './pages/admin/lawyers/LawyersListPage';
import AddLawyerPage from './pages/admin/lawyers/AddLawyerPage';
import EditLawyerPage from './pages/admin/lawyers/EditLawyerPage';
import UsersListPage from './pages/admin/users/UsersListPage';
import EditUserPage from './pages/admin/users/EditUserPage';
import AddUserPage from './pages/admin/users/AddUserPage';
import ServiceRequestsListPage from './pages/admin/service-requests/ServiceRequestsListPage';
import EditServiceRequestPage from './pages/admin/service-requests/EditServiceRequestPage';
import SubscriptionsListPage from './pages/admin/subscriptions/SubscriptionsListPage';
import AddSubscriptionPage from './pages/admin/subscriptions/AddSubscriptionPage';
import EditSubscriptionPage from './pages/admin/subscriptions/EditSubscriptionPage';
import SubscribersListPage from './pages/admin/subscribers/SubscribersListPage';
import EditSubscriberPage from './pages/admin/subscribers/EditSubscriberPage';
import InvoicesListPage from './pages/admin/invoices/InvoicesListPage';
import AddInvoicePage from './pages/admin/invoices/AddInvoicePage';
import EditInvoicePage from './pages/admin/invoices/EditInvoicePage';
import ComplaintsListPage from './pages/admin/complaints/ComplaintsListPage';
import ViewComplaintPage from './pages/admin/complaints/ViewComplaintPage';
import NotificationsListPage from './pages/admin/notifications/NotificationsListPage';
import AddNotificationPage from './pages/admin/notifications/AddNotificationPage';
import DirectoryPage from './pages/public/DirectoryPage';
import PublicServicesPage from './pages/public/PublicServicesPage';
import CommuniquesResultPage from './pages/public/CommuniquesResultPage';
import ManageCommuniquePage from './pages/admin/communiques/ManageCommuniquePage';
import CommuniquesListPage from './pages/admin/communiques/CommuniquesListPage';
import CommuniqueDetailsPage from './pages/admin/communiques/CommuniqueDetailsPage';

import LawyerDashboardPage from './pages/lawyers/LawyerDashboardPage';
import NewServiceRequestPage from './pages/lawyers/NewServiceRequestPage'; 
import RenewSubscriptionPage from './pages/lawyers/RenewSubscriptionPage';
import AdminCreateRequestPage from './pages/admin/service-requests/AdminCreateRequestPage';
//import ProfilePage from './pages/ProfilePage'; // استيراد الصفحة الجديدة
// ... استورد باقي صفحاتك هنا (LawyersList, InvoicesList, etc.)

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Toaster position="top-center" reverseOrder={false} />
        <Router>
          <Routes>
            {/* المسارات العامة */}
            <Route path="/directory" element={<DirectoryPage />} />   
            <Route path="/services" element={<PublicServicesPage />} />
            <Route path="/communiques-results" element={<CommuniquesResultPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* المسارات المحمية التي تستخدم التخطيط الرئيسي */}
            <Route element={<Layout />}>
        {/* --- مسارات المشرف --- */}
              {/* الصفحات الفرعية التي ستعرض داخل <Outlet> في Layout 
              <Route index element={<Dashboard />} /> */}
        
               {/* مسار المشرف */}
        <Route
          path="/admin/dashboard"
          element={
            // استخدام UserRole.ADMIN بدلاً من "admin"
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <Dashboard />
            </ProtectedRoute>
          }
        /> 
        <Route
  path="/admin/manage-communiques"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <ManageCommuniquePage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/communiques/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <CommuniquesListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/communiques/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <CommuniqueDetailsPage />
    </ProtectedRoute>
  }
/>

        <Route
  path="/admin/service-requests/new"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AdminCreateRequestPage />
    </ProtectedRoute>
  }
/>      
        <Route
          path="/admin/user-approvals"
          element={
            // استخدام UserRole.ADMIN بدلاً من "admin"
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <UserApprovals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/subscribers/training-requests"
          element={
            <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
              <TrainingRequestsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/data-import"
          element={
        <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
           <DataImportPage />
        </ProtectedRoute>
         }
         />
        <Route
          path="/admin/services-management"
          element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <ServicesManagementPage />
          </ProtectedRoute>
        } />
        <Route
          path="/admin/trainees/list"
          element={
         <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <TraineesListPage />
         </ProtectedRoute>
        }
        />
         {/* !! المسار الجديد الذي ستضيفه !! */}
        <Route
          path="/admin/trainees/add" 
          element={
        <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
           <AddTraineePage />
        </ProtectedRoute>
        }
        />
        <Route
          path="/admin/trainees/edit/:id" // <-- المسار الديناميكي
          element={
        <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
           <EditTraineePage />
        </ProtectedRoute>
       }
      />
      <Route
  path="/admin/lawyers/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <LawyersListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/lawyers/add"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AddLawyerPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/lawyers/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditLawyerPage />
    </ProtectedRoute>
  }
/>
  <Route
  path="/admin/users/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <UsersListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/users/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditUserPage />
    </ProtectedRoute>
  }
/>
    <Route
  path="/admin/users/add"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AddUserPage />
    </ProtectedRoute>
  }
/>
{/* === قسم إدارة طلبات الخدمات === */}
<Route
  path="/admin/service-requests/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <ServiceRequestsListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/service-requests/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditServiceRequestPage />
    </ProtectedRoute>
  }
/>
   <Route
  path="/admin/subscriptions/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <SubscriptionsListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/subscriptions/add"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AddSubscriptionPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/subscriptions/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditSubscriptionPage />
    </ProtectedRoute>
  }
/>
  <Route
  path="/admin/subscribers/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <SubscribersListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/subscribers/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditSubscriberPage />
    </ProtectedRoute>
  }
/>
  <Route
  path="/admin/invoices/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <InvoicesListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/invoices/add"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AddInvoicePage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/invoices/edit/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <EditInvoicePage />
    </ProtectedRoute>
  }
/>
   <Route
  path="/admin/complaints/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <ComplaintsListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/complaints/view/:id"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <ViewComplaintPage />
    </ProtectedRoute>
  }
/>
  <Route
  path="/admin/notifications/list"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <NotificationsListPage />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/notifications/add"
  element={
    <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
      <AddNotificationPage />
    </ProtectedRoute>
  }
/>

 {/* --- مسارات المحامي --- */}
  <Route
    path="/lawyer/dashboard"
    element={
      <ProtectedRoute allowedRoles={[UserRole.LAWYER]}>
        <LawyerDashboardPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/lawyer/new-service-request"
    element={
      <ProtectedRoute allowedRoles={[UserRole.LAWYER, UserRole.TRAINEE, UserRole.SUBSCRIBER]}>
        <NewServiceRequestPage />
      </ProtectedRoute>
    }
  />
   <Route
    path="/lawyer/renew-subscription"
    element={
      <ProtectedRoute allowedRoles={[UserRole.LAWYER]}>
        <RenewSubscriptionPage />
      </ProtectedRoute>
    }
  />


         {/* --- مسارات المشترك الجديد --- */}
        <Route
          path="/subscriber/dashboard"
          element={
            // استخدام UserRole.SUBSCRIBER بدلاً من "subscriber"
            <ProtectedRoute allowedRoles={[UserRole.SUBSCRIBER]}>
              <SubscriberDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscriber/training-application"
          element={
            // استخدام UserRole.SUBSCRIBER بدلاً من "subscriber"
            <ProtectedRoute allowedRoles={[UserRole.SUBSCRIBER]}>
              <TrainingApplication />
            </ProtectedRoute>
          }
        />

        {/* ... (مسارات المتدرب والمحامي المستقبلية ستتبع نفس النمط) ... */}
        
         {/* صفحة الملف الشخصي (مشتركة للجميع) 
        <Route
          path="/profile"
          element={
            // استخدام قيم enum لجميع الأدوار
            <ProtectedRoute allowedRoles={[
              UserRole.ADMIN,
              UserRole.SUBSCRIBER,
              UserRole.TRAINEE,
              UserRole.LAWYER
            ]}>
              <ProfilePage />
            </ProtectedRoute>
          }
        /> */}
        
        {/* مسار افتراضي بعد تسجيل الدخول */}
       <Route path="/" element={<HomePage />} /> 
            </Route> 
             <Route path="/unauthorized" element={<UnauthorizedPage />} />
            {/* يمكنك إضافة مسار لصفحة 404 هنا */}
            {/* <Route path="*" element={<NotFoundPage />} /> */}

          </Routes>
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
